import {
  Typography,
  Box,
  Button,
  IconButton,
  Avatar,
  useMediaQuery,
  Tab,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Modal,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TablePagination,
  Container,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import "./members_list.css";
import { useNavigate } from "react-router-dom";
import TextInput from "../../../components/TextInput/TextInput";
import { useForm } from "react-hook-form";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import LandLinePhoneFormatter from "../../../components/PhoneFormatter/LandLinePhoneFormatter";
import getEventController from "../Controller/getEvent_controller";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import axios from "axios";
// import Cropper from "react-easy-crop";
import { getCroppedImg } from "./cropImage"; // Utility for extracting cropped image
import PeopleIcon from "@mui/icons-material/People";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonIcon from "@mui/icons-material/Person";

function AvatarButton() {}

const MembersList = () => {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const memberId = localStorage.getItem("memberId");
  const email = localStorage.getItem("email");
  const userId = localStorage.getItem("userId");

  const [CorporateMemberList, setCorporateMemberList] = useState([]); // State to store corporate member data
  const [IndividualMemberList, setIndividualMemberList] = useState([]); // State to store corporate member data
  const [AffiliateCorporateMemberList, setAffiliateCorporateMemberList] =
    useState([]);
  const [AffiliateIndividualMemberList, setAffiliateIndividualMemberList] =
    useState([]);
  const [AssociateMemberList, setAssociateMemberList] = useState([]);
  const [HonoraryMemberList, setHonorayMemberList] = useState([]);

  //Corporate Member
  useEffect(() => {
    getEventController
      .getCorporateMembersList()
      .then((response) => {
        if (Array.isArray(response)) {
          // console.log("API Response:", response);

          const memberData = response.map((item) => ({
            membership_no: item.memberID || "Not Available",
            mall_name: item.complex_representing || item.company_name,
            email: item.email || "Not Available",
            telephone_no: item.telephone_no || "Not Available",
            website:
              item.website && item.website.trim() !== ""
                ? item.website
                : "Not Available",
          }));

          setCorporateMemberList(memberData);
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, []);

  //Individual Member
  useEffect(() => {
    getEventController
      .getIndividualMembersList()
      .then((response) => {
        if (Array.isArray(response)) {
          // console.log("API Response:", response);

          const IndividualMemberData = response.map((item) => ({
            membership_no: item.memberID || "Not Available",
            full_name: item.individual_fullname || "Not Available",
            email: item.email || "Not Available",
            telephone_no: item.telephone_no || "Not Available",
          }));

          setIndividualMemberList(IndividualMemberData);
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, []);

  //Affiliate Corporate Member
  useEffect(() => {
    getEventController
      .getAffiliateCorporateMembersList()
      .then((response) => {
        if (Array.isArray(response)) {
          console.log("API Response:", response);

          const AffiliateCorporateMemberData = response.map((item) => ({
            membership_no: item.memberID || "Not Available",
            full_name: item.individual_fullname || item.company_name,
            email: item.email || "Not Available",
            telephone_no: item.telephone_no || "Not Available",
          }));

          setAffiliateCorporateMemberList(AffiliateCorporateMemberData);
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, []);

  //Affiliate Individual Member
  useEffect(() => {
    getEventController
      .getAffiliateIndividualMembersList()
      .then((response) => {
        if (Array.isArray(response)) {
          console.log("API Response:", response);

          const AffiliateIndividualMemberData = response.map((item) => ({
            membership_no: item.memberID || "Not Available",
            full_name: item.individual_fullname || item.company_name,
            email: item.email || "Not Available",
            telephone_no: item.telephone_no || "Not Available",
          }));

          setAffiliateIndividualMemberList(AffiliateIndividualMemberData);
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, []);

  //Associate Member
  useEffect(() => {
    getEventController
      .getAssociateMembersList()
      .then((response) => {
        if (Array.isArray(response)) {
          console.log("API Response:", response);

          const AssociateMemberData = response.map((item) => ({
            membership_no: item.memberID || "Not Available",
            full_name: item.individual_fullname || item.company_name,
            email: item.email || "Not Available",
            telephone_no: item.telephone_no || "Not Available",
          }));

          setAssociateMemberList(AssociateMemberData);
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, []);

  //Honorary Member
  useEffect(() => {
    getEventController
      .getHonoraryMembersList()
      .then((response) => {
        if (Array.isArray(response)) {
          console.log("API Response:", response);

          const HonoraryMemberData = response.map((item) => ({
            membership_no: item.memberID || "Not Available",
            full_name: item.individual_fullname || item.company_name,
            email: item.email || "Not Available",
            telephone_no: item.telephone_no || "Not Available",
          }));

          setHonorayMemberList(HonoraryMemberData);
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, []);

  const renderMemberCard = (member) => (
    <Paper
      elevation={4}
      sx={{
        width: "280px",
        height: "180px",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#d32f2f",
          color: "white",
          padding: "12px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        <Typography variant="h6" fontSize="15px" fontWeight="bold" noWrap>
          {member.full_name}
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor: "white",
          padding: "14px",
          textAlign: "left",
          color: "black",
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: "14px", marginBottom: "6px", color: "#333" }}
        >
          <strong style={{ color: "#666" }}>Email:</strong>{" "}
          {member.email &&
          member.email.trim() !== "" &&
          member.email !== "Not Available" ? (
            <a
              href={`mailto:${member.email}?subject=Hello`}
              style={{
                color: "#1565c0",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              {member.email}
            </a>
          ) : (
            <span style={{ color: "#888" }}>Not Available</span>
          )}
        </Typography>

        <Typography
          variant="body2"
          sx={{ fontSize: "14px", marginBottom: "6px", color: "#333" }}
        >
          <strong style={{ color: "#666" }}>Phone:</strong>{" "}
          {member.telephone_no && member.telephone_no.trim() !== ""
            ? member.telephone_no
            : "Not Available"}
        </Typography>
      </Box>
    </Paper>
  );

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        // <div className="edit-profile">
        //   <Box sx={{ display: "flex" }}>
        //     <Box component="main" sx={{ flexGrow: 1, p: 3, height: "auto" }}>
        //       {/* <DrawerHeader /> */}
        //       {/* {showAlertSuccess && (
        //         <Alert severity="success" sx={{ mb: 2 }}>
        //           {alertSuccessMsg}
        //         </Alert>
        //       )} */}

        //       <form>
        //         <Box sx={{ flexGrow: 1 }}>
        //           <div className="sm-personal-details-title">
        //             <span>Personal Details</span>
        //           </div>
        //           <Grid container spacing={2}>
        //             <Grid
        //               size={{ xs: 12, md: 12 }}
        //               sx={{
        //                 display: "flex",
        //                 justifyContent: "center",
        //               }}
        //             >
        //               <AvatarButton />
        //             </Grid>
        //             {/* Name */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Name</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Email */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Email</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Address */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Address</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Place of Birth */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Place of Birth</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Phone Number */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Phone Number</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Race */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Race</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Gender */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Gender</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Nationality */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Nationality</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Marital Status */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Marital Status</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Academic Qualification */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Academic Qualification</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //           </Grid>

        //           <div className="office-details-title">
        //             <span>Office/Company Details</span>
        //           </div>

        //           <Grid container spacing={2}>
        //             {/* Office Email */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Office Email</label>
        //               <TextInput
        //                 type="email"
        //                 name="companyEmail"
        //                 {...register("companyEmail", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.companyEmail ? errors.companyEmail.message : ""
        //                 }
        //                 onEmailCheck={(error) => {
        //                   if (error?.type === "invalidFormat") {
        //                     setError("companyEmail", {
        //                       type: "manual",
        //                       message: error.message,
        //                     });
        //                   } else if (error?.type === "duplicate") {
        //                     setError("companyEmail", {
        //                       type: "manual",
        //                       message: error.message,
        //                     });
        //                   } else if (error?.type === "duplicateInForm") {
        //                     setError("companyEmail", {
        //                       type: "manual",
        //                       message: error.message,
        //                     });
        //                   } else {
        //                     clearErrors("companyEmail");
        //                   }
        //                 }}
        //                 control={control}
        //                 getValues={getValues}
        //               />
        //             </Grid>
        //             {/* Office Tel No */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Office Tel No.</label>
        //               <LandLinePhoneFormatter
        //                 name="companyTelephoneNo"
        //                 onErrorCheck={
        //                   errors.companyTelephoneNo
        //                     ? errors.companyTelephoneNo.message
        //                     : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Fax No */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Fax No.</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("companyFax", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.companyFax ? errors.companyFax.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Nature Of Work */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Nature of Work</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //             {/* Years with Company */}
        //             <Grid size={{ xs: 12, md: 12 }}>
        //               <label>Years with Company</label>
        //               <TextInput
        //                 type="text"
        //                 {...register("eventName", {
        //                   required: "This field is required",
        //                 })}
        //                 onErrorCheck={
        //                   errors.eventName ? errors.eventName.message : ""
        //                 }
        //                 control={control}
        //               />
        //             </Grid>
        //           </Grid>

        //           <Box textAlign="center">
        //             <Button
        //               sx={{
        //                 borderRadius: "20px",
        //                 mt: 4,
        //                 mb: 4,
        //                 width: "100%",
        //                 height: "48px",
        //                 backgroundColor: "#d33333",
        //                 textTransform: "none",
        //               }}
        //               variant="contained"
        //               type="submit"
        //             >
        //               <Typography variant="h6">Update Profile</Typography>
        //             </Button>
        //           </Box>
        //         </Box>
        //       </form>
        //     </Box>
        //   </Box>
        // </div>
        <></>
      ) : (
        <div className="edit-profile">
          {/* Back Button */}
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
          </div>
          {/* Tab List */}
          <Box sx={{ width: "100%", typography: "body1", padding: "10px" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  sx={{
                    ".MuiTab-root": {
                      minHeight: "50px", // Decrease height
                      borderRadius: "8px 8px 0 0", // Rounded corners on top-left and top-right
                      fontWeight: "bold", // Bold font
                      textTransform: "none", // Disable uppercase text
                      "&:hover": {
                        textDecoration: "none", // Remove underline on hover
                      },
                      transition: "all 0.3s ease-in-out", // Smooth transition for all properties
                    },
                    ".Mui-selected": {
                      backgroundColor: "#d33333", // Example active tab background color
                      color: "white !important", // Example active tab text color
                      borderBottom: "none", // Remove underline when selected
                    },
                    ".MuiTabs-indicator": {
                      display: "none", // Remove the default blue underline
                    },
                  }}
                >
                  <Tab
                    icon={<PeopleIcon />}
                    iconPosition="start"
                    label="Corporate Members"
                    value="1"
                  />
                  <Tab
                    icon={<PersonIcon />}
                    iconPosition="start"
                    label="Individual Members"
                    value="2"
                  />
                  <Tab
                    icon={<PeopleOutlineIcon />}
                    iconPosition="start"
                    label="Other Members"
                    value="3"
                  />
                </TabList>
              </Box>
              {/* Corporate Members */}
              <TabPanel value="1">
                <Container maxWidth="lg">
                  <Grid container spacing={2} justifyContent="center">
                    {CorporateMemberList.map((member, index) => (
                      <Grid item xs={12} sm={6} md={2.4} key={index}>
                        <Paper
                          elevation={3}
                          sx={{
                            width: "260px",
                            height: "150px", // Fixed size for consistency
                            borderRadius: "8px",
                            overflow: "hidden",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                          }}
                        >
                          {/* Red Header for Mall Name */}
                          <Box
                            sx={{
                              backgroundColor: "#d32f2f",
                              color: "white",
                              padding: "10px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="h6"
                              fontSize="14px"
                              fontWeight="bold"
                              noWrap
                            >
                              {member.mall_name}
                            </Typography>
                          </Box>

                          {/* White Body for Details */}
                          <Box
                            sx={{
                              backgroundColor: "white",
                              padding: "16px",
                              textAlign: "left",
                              color: "black",
                              borderRadius: "0 0 8px 8px",
                              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {/* Email: Clickable only if valid */}
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                marginBottom: "6px",
                                color: "#333",
                              }}
                            >
                              <strong style={{ color: "#666" }}>Email:</strong>{" "}
                              {member.email &&
                              member.email.trim() !== "" &&
                              member.email !== "Not Available" ? (
                                <a
                                  href={`mailto:${member.email}?subject=Hello`}
                                  style={{
                                    color: "#1565c0",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                    transition: "all 0.3s ease",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.textDecoration = "none")
                                  }
                                >
                                  {member.email}
                                </a>
                              ) : (
                                <span style={{ color: "#888" }}>
                                  Not Available
                                </span>
                              )}
                            </Typography>

                            {/* Phone */}
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                marginBottom: "6px",
                                color: "#333",
                              }}
                            >
                              <strong style={{ color: "#666" }}>Phone:</strong>{" "}
                              {member.telephone_no &&
                              member.telephone_no.trim() !== ""
                                ? member.telephone_no
                                : "Not Available"}
                            </Typography>

                            {/* Website: Clickable only if valid */}
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "14px", color: "#333" }}
                            >
                              <strong style={{ color: "#666" }}>
                                Website:
                              </strong>{" "}
                              {member.website &&
                              member.website.trim() !== "" &&
                              member.website !== "Not Available" ? (
                                <a
                                  href={
                                    member.website.startsWith("http")
                                      ? member.website
                                      : `https://${member.website}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#1565c0",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                    transition: "all 0.3s ease",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.textDecoration = "none")
                                  }
                                >
                                  {member.website}
                                </a>
                              ) : (
                                <span style={{ color: "#888" }}>
                                  Not Available
                                </span>
                              )}
                            </Typography>
                          </Box>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Container>
              </TabPanel>
              {/* Individual Members */}
              <TabPanel value="2">
                <Container maxWidth="lg">
                  <Grid container spacing={2} justifyContent="center">
                    {IndividualMemberList.map((member, index) => (
                      <Grid item xs={12} sm={6} md={2.4} key={index}>
                        <Paper
                          elevation={4}
                          sx={{
                            width: "300px",
                            height: "160px", // Fixed size for consistency
                            borderRadius: "8px",
                            overflow: "hidden",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                          }}
                        >
                          {/* Red Header for Mall Name */}
                          <Box
                            sx={{
                              backgroundColor: "#d32f2f",
                              color: "white",
                              padding: "10px",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="h6"
                              fontSize="14px"
                              fontWeight="bold"
                              noWrap
                            >
                              {member.full_name}
                            </Typography>
                          </Box>

                          {/* White Body for Details */}
                          <Box
                            sx={{
                              backgroundColor: "white",
                              padding: "14px",
                              textAlign: "left",
                              color: "black",
                              // display: "flex",
                              // flexDirection: "column",
                              justifyContent: "space-between",
                              height: "100%", // Ensures proper alignment
                            }}
                          >
                            {/* Email: Clickable only if valid */}
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                marginBottom: "6px",
                                color: "#333",
                              }}
                            >
                              <strong style={{ color: "#666" }}>Email:</strong>{" "}
                              {member.email &&
                              member.email.trim() !== "" &&
                              member.email !== "Not Available" ? (
                                <a
                                  href={`mailto:${member.email}?subject=Hello`}
                                  style={{
                                    color: "#1565c0",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                    transition: "all 0.3s ease",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.textDecoration =
                                      "underline")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.textDecoration = "none")
                                  }
                                >
                                  {member.email}
                                </a>
                              ) : (
                                <span style={{ color: "#888" }}>
                                  Not Available
                                </span>
                              )}
                            </Typography>

                            {/* Phone */}
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                marginBottom: "6px",
                                color: "#333",
                              }}
                            >
                              <strong style={{ color: "#666" }}>Phone:</strong>{" "}
                              {member.telephone_no &&
                              member.telephone_no.trim() !== ""
                                ? member.telephone_no
                                : "Not Available"}
                            </Typography>
                          </Box>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Container>
              </TabPanel>
              {/* Other Members */}
              <TabPanel value="3">
                <Container maxWidth="lg">
                  {/* Honorary Members */}
                  {HonoraryMemberList.length > 0 && (
                    <>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#d32f2f",
                          textAlign: "left",
                          marginTop: "24px",
                          marginBottom: "8px",
                        }}
                      >
                        Honorary Members
                      </Typography>
                      <Divider
                        sx={{ borderBottomWidth: "2px", marginBottom: "16px" }}
                      />

                      <Grid container spacing={3} justifyContent="center">
                        {HonoraryMemberList.map((member, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={2.4}
                            key={`honor-${index}`}
                          >
                            {renderMemberCard(member)}
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  )}
                  {/* Associate Members */}
                  {AssociateMemberList.length > 0 && (
                    <>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#d32f2f",
                          textAlign: "left",
                          marginTop: "24px",
                          marginBottom: "8px",
                        }}
                      >
                        Associate Members
                      </Typography>
                      <Divider
                        sx={{ borderBottomWidth: "2px", marginBottom: "16px" }}
                      />

                      <Grid container spacing={3} justifyContent="center">
                        {AssociateMemberList.map((member, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={2.4}
                            key={`assoc-${index}`}
                          >
                            {renderMemberCard(member)}
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  )}
                  {/* Affiliate Corporate Members */}
                  {AffiliateCorporateMemberList.length > 0 && (
                    <>
                      {/* Full-width Title & Divider */}
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#d32f2f",
                          textAlign: "left",
                          marginBottom: "8px",
                        }}
                      >
                        Affiliate Corporate Members
                      </Typography>
                      <Divider
                        sx={{ borderBottomWidth: "2px", marginBottom: "16px" }}
                      />

                      {/* Member Cards in Grid */}
                      <Grid container spacing={3} justifyContent="center">
                        {AffiliateCorporateMemberList.map((member, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={2.4}
                            key={`aff-corp-${index}`}
                          >
                            {renderMemberCard(member)}
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  )}

                  {/* Affiliate Individual Members */}
                  {AffiliateIndividualMemberList.length > 0 && (
                    <>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#d32f2f",
                          textAlign: "left",
                          marginTop: "24px",
                          marginBottom: "8px",
                        }}
                      >
                        Affiliate Individual Members
                      </Typography>
                      <Divider
                        sx={{ borderBottomWidth: "2px", marginBottom: "16px" }}
                      />

                      <Grid container spacing={3} justifyContent="center">
                        {AffiliateIndividualMemberList.map((member, index) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={2.4}
                            key={`aff-indiv-${index}`}
                          >
                            {renderMemberCard(member)}
                          </Grid>
                        ))}
                      </Grid>
                    </>
                  )}
                </Container>
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      )}
    </React.Fragment>
  );
  // }
};

export default MembersList;
